import { cx } from '@/utils';

import { Skeleton } from '@/components/ui/Skeleton';

import styles from './styles.module.css';

/**
 * NavigationBarSkeleton
 * Skeleton loader que se muestra mientras el árbol de navegación está cargando.
 * Simula la estructura visual del NavigationBar con elementos animados.
 */
const NavigationBarSkeleton = () => {
  return (
    <nav
      role="navigation"
      aria-label="Cargando menú de navegación"
      aria-busy="true"
      className={cx(styles.nav, styles.links, 'relative h-[69px] border-b-[3px] border-b-primary')}
    >
      <div className={cx(styles.container, 'lg:inner mx-0 overflow-x-auto scrollbar-none')}>
        {/* Skeleton para el botón de Inicio */}
        <div className="flex h-full items-center px-4 py-4">
          <Skeleton className="h-4 w-4 rounded bg-tundora/20" />
          <Skeleton className="ml-2 h-4 w-12 bg-tundora/20" />
        </div>

        {/* Skeletons para los items del menú */}
        <div className="flex h-full flex-1 items-center px-4 py-4">
          <Skeleton className="h-4 w-24 bg-tundora/20" />
        </div>
        <div className="flex h-full flex-1 items-center px-4 py-4">
          <Skeleton className="h-4 w-32 bg-tundora/20" />
        </div>
        <div className="flex h-full flex-1 items-center px-4 py-4">
          <Skeleton className="h-4 w-20 bg-tundora/20" />
        </div>
        <div className="flex h-full flex-1 items-center px-4 py-4">
          <Skeleton className="h-4 w-28 bg-tundora/20" />
        </div>
        <div className="flex h-full flex-1 items-center px-4 py-4">
          <Skeleton className="h-4 w-24 bg-tundora/20" />
        </div>
      </div>
    </nav>
  );
};

export default NavigationBarSkeleton;
